import { reviews } from "@/app/(site)/data/reviews";
import ReviewCard from "../cards/ReviewCard";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function OurProcess() {
  return (
    <section className="flex flex-col w-full py-16 md:py-20 px-6 md:px-30">
      <div className="flex flex-col w-full items-center justify-center text-center">

        {/* Heading */}
        <div className="flex flex-col gap-4 text-primary max-w-[800px]">
          <h3 className="text-[28px] md:text-[40px] leading-tight md:leading-[48px] font-lora font-bold">
            What Our Clients Have To Say
          </h3>

          <p className="text-[17px] md:text-[20px] font-light leading-[26px] md:leading-[30px] px-2 md:px-0">
            A clear, step-by-step approach designed to protect your interests and guide you with confidence
          </p>
        </div>

        {/* Slider */}
        <div className="w-full pt-10 md:pt-12">
          <Swiper
            modules={[Autoplay]}
            loop={true}
            spaceBetween={10}
            slidesPerView={3}
            autoplay={{
              delay: 4000,
              pauseOnMouseEnter: false,
              disableOnInteraction: false,
            }}
            speed={1000}
            breakpoints={{
              320: { slidesPerView: 1.15, spaceBetween: 16 },
              480: { slidesPerView: 1.4, spaceBetween: 18 },
              640: { slidesPerView: 2, spaceBetween: 24 },
              1024: { slidesPerView: 3, spaceBetween: 28 },
              1280: { slidesPerView: 3, spaceBetween: 30 },
            }}
          >
            {reviews.map((review, index) => (
              <SwiperSlide key={index}>
                <ReviewCard reviewer={review} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
